import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoleDto } from '../interfaces/roles/role-dto.interface';
import { DropdownRole } from '../interfaces/roles/dropdown-role.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private iAdminURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iAdminURL = config.iAdminApiBaseURL;
  }
  getRoles(): Observable<RoleDto[]> {
    return this.http.get<RoleDto[]>(`${this.iAdminURL}/Global/Roles`);
  }

  getRolesMappedToPrimeNGDropdowns(): Observable<DropdownRole[]> {
    return this.getRoles().pipe(
      map((res: RoleDto[]) => {
        return res.map((role) => ({
          ...role,
          label: role.description,
          value: role.id,
        }));
      })
    );
  }
}
